import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 利息区分(帳簿設定) */
enum InterestClassBookSetting {
  interestExcluded = '1',
  interestIncluded = '2',
}

const nameConfig = {
  interestExcluded: new Map([
    [Locale.ja, '利子抜き'],
    [Locale.en, 'Interest Excluded'],
  ]),
  interestIncluded: new Map([
    [Locale.ja, '利子込み'],
    [Locale.en, 'Interest Included'],
  ]),
};

const toEnum = rawValueToEnum(InterestClassBookSetting, '');
const toDisplay = enumToName(InterestClassBookSetting, nameConfig);
const toDisplayWithPrefix = enumToName(InterestClassBookSetting, nameConfig, { prefix: true });

export const interestClassBookSetting = {
  enum: InterestClassBookSetting,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { InterestClassBookSetting };
